import { useEffect } from 'react';
import { create } from 'zustand';

export const minuteBucketMs = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.floor(numeric / 60_000) * 60_000;
};

const useWidgetMinuteFocusStore = create((set, get) => ({
  minuteMs: null,
  sourceId: null,
  setFocusedMinute: (sourceId, value) => {
    const minuteMs = minuteBucketMs(value);
    if (!sourceId || minuteMs == null) return;
    set({ minuteMs, sourceId });
  },
  clearFocusedMinute: (sourceId) => {
    if (get().sourceId !== sourceId) return;
    set({ minuteMs: null, sourceId: null });
  },
}));

export function useFocusedMinuteSourceCleanup(sourceId) {
  const clearFocusedMinute = useWidgetMinuteFocusStore(
    (state) => state.clearFocusedMinute,
  );

  useEffect(
    () => () => clearFocusedMinute(sourceId),
    [clearFocusedMinute, sourceId],
  );
}

export default useWidgetMinuteFocusStore;
